import { useGetData, UseGetDataResultReturnType } from "@/component/PageComponent/hooks/requst"
import { CardModule, CustomReportConfig } from "@/component/common/report/reportConfigModel"
import { Card, Col, Flex, Row } from "antd"
import React from "react"
import styled from "styled-components"
import { QuickBiReportDataResponse, serviceQuickBiReportData, serviceQuickBiReportDataV2 } from "../services/bi/bi"
import { isError } from "@/component/common/error"
import { DataCard } from "../Display/Display"
import { ColProps } from 'antd'
import _, { extend } from "lodash"
import { FORMAT_STRING, numberThousandSeparatorByValueType } from "../share/numberFormat"
import { ReportConfig,ReportParams } from "@/component/common/report/report"
import { CountType } from "@/component/ReportCommon/share/params"
import { useCustomCardHooks } from "@/component/ReportCommon/CustomCard/CustomCard"
import { isErrorPc } from "@/component/PageComponent/errorPc"

const CardStyled = styled.div<{$isWrap:boolean,$cardWidth:string, $rowFlex?:number}>`
  width: 100%;
  display: flex;
  .card-wrap {
    min-width: 150px;
    flex: ${p => p.$isWrap ? '0 0 '+p.$cardWidth : '1'};
    
  }
  ${p => p.$isWrap ? `.card-wrap:nth-child(${p.$rowFlex || 0}n) .data-card{
      margin-right: 0;
    }`: `.card-wrap:last-child .data-card{margin-right: 0;}`}
  .content{
    width: 100%;
    flex-wrap: ${p=> p.$isWrap ? 'wrap' :'nowrap'  };
    overflow: hidden;
  }
  .ant-card{
    border-radius: 0;
  }
`

interface sortParams{
  dataIndex:string
  order:string
}

interface CustomCardProps {
  reportConfig: ReportConfig,
  moduleItem: CardModule
  dataHandler: UseGetDataResultReturnType<ReportParams> 
  style?: React.HTMLAttributes<'div'>['style']
}

export function CustomCard(props: CustomCardProps) {
  const { reportConfig, moduleItem, dataHandler, style = {} } = props
  // const params = { ...dataHandler.params } 
  // const { list } = moduleItem
  // const [cardReportData, setCardReportData] = React.useState<QuickBiReportDataResponse>()
  // const getData = async ()=>{
  //   const {count,sortParams,...cardParams}  = dataHandler.params
    
  //   let templateFieldsList = moduleItem.list.filter(item => item.valueType).map(item =>{
  //     return {
  //       code: item.valueField,
  //       valueType: item.valueType
  //     }
  //   })
    
  //   let template_fields = JSON.stringify(templateFieldsList)
  //   let res = await serviceQuickBiReportData({report:reportConfig.config.slug,source:moduleItem.source,template_fields,...cardParams});
  //   if(isError(res)){
  //     return
  //   }
  //   let templateFieldsObj = _.keyBy(moduleItem.list,'valueField')
  //   res.data.listsData = res.data.listsData?.map(item=>{
  //     Object.keys(item).forEach(key=>{
  //       if(templateFieldsObj[key]){
  //         let valueType = templateFieldsObj[key].valueType
  //         item[key]= numberThousandSeparatorByValueType(item[key],valueType || FORMAT_STRING)
  //       }
  //     })
  //     return item
  //   })
  //   setCardReportData(res.data)
  // }
  // React.useEffect(() => {
    
  //   if(dataHandler.params?.count===CountType.isRequestAll || dataHandler.params.count===undefined){
  //     getData()
  //   }
  // }, [dataHandler.params])
  // let cardInfo = (cardReportData?.listsData || [])[0]

  let { list,cardInfo,rowFlex } = useCustomCardHooks({...props,getBiReportCardData:serviceQuickBiReportDataV2,isError: isErrorPc})

  if (!cardInfo) {
    return null
  }
  let isWrap = false
  let cardWidth = '0'
  // rowFlex = 3
  if(rowFlex !== undefined){
    isWrap = true
    cardWidth = `${100/rowFlex}%`
  }
  return <CardStyled style={style} $isWrap={isWrap} $cardWidth={cardWidth} $rowFlex={rowFlex}>
    <Flex wrap="wrap"  justify="flex-start" flex={1} className="content" >
      {list.map((item, index) => {
        let { valueField, relativeRatioField, hideRelativeRatio, showRelativeArrow, ratioLabel, upColor, downColor, titleTip } = item;
        let value = cardInfo[valueField] || '';
        let relativeRatio = cardInfo[relativeRatioField] || '';
        relativeRatio = (Number(relativeRatio) * 100).toFixed(2)

        return <div className='card-wrap' key={index} >
          <DataCard title={item.name} 
          number={value} 
          relativeRatio={relativeRatio} 
          hideRelativeRatio={relativeRatioField == undefined}
          showRelativeArrow={showRelativeArrow}
          ratioLabel={ratioLabel}
          upColor={upColor}
          downColor={downColor}
          titleTip={titleTip}
          />
        </div>
      })}
    </Flex>

  </CardStyled>
}
